import { render, staticRenderFns } from "./advertising‌Banner.vue?vue&type=template&id=44af88bf"
import script from "./advertising‌Banner.vue?vue&type=script&lang=js"
export * from "./advertising‌Banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports